import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import RichTextEditor from 'components/form/Formik/RichTextEditor';

const HelpContent = ({ name }) => {
  const [show, setShow] = useState();
  return (
    <Box>
      <Button color="primary" variant="text" onClick={() => setShow(!show)}>Add help content</Button>
      <Collapse in={show}>
        <RichTextEditor
          name={name}
          placeholder="Enter help content"
        />
      </Collapse>
    </Box>
  )
};

export default HelpContent;